import { textColorWeb } from '@/utils/luJhu/lujhuLib'
import { filterMapping } from '@/utils/luJhu/filterMapping'

export const commonMethodMixin = {
  methods: {
    initHighLightObj(data) {
      const hightLightInitObj = {}
      data.forEach((type) => {
        if (!hightLightInitObj[type.field]) {
          hightLightInitObj[type.field] = {}
        }
        hightLightInitObj[type.field][type.ruleType] = ''
      })

      this.hightlightObj = hightLightInitObj
    },
    changeTab(name) {
      this.mode = name
      this.setDefaultSelect(this.lotteryType)
      this.initHighLightObj(this.rowData)
    },
    setDefaultSelect(lotteryType) {
      const type = lotteryType

      // 複選名次
      this.selectBallFilter = filterMapping[type].ballData
      // 複選路珠
      this.selectTypeFilter = filterMapping[type].typeData
      // 单選名次
      this.selectSingleBall = 'hm1'
      // 单選路珠
      this.selectSingleType = 'hmDanShuang'
    },
    tabItems() {
      return {
        combine: '綜合模式',
        number: '单选模式',
        type: '两面模式'
      }
    },
    textColor(name) {
      return textColorWeb(name)
    },
    handleHighlight(ball, point) {
      if (
        point.length >= Number(this.hightlightObj[ball.field][ball.ruleType].split('-')[0]) &&
        point[0] === this.hightlightObj[ball.field][ball.ruleType].split('-')[1]
      ) {
        return 'hightlight'
      }
    },
    handleSortLight(ball) {
      const count = `${ball.field}-count-${ball.ruleType}`
      const type = `${ball.field}-type-${ball.ruleType}`

      this.hightlightObj = Object.assign({}, this.hightlightObj, {
        [ball.field]: Object.assign({}, this.hightlightObj[ball.field], {
          [ball.ruleType]: `${this.$refs[count][0].value}-${this.$refs[type][0].value}`
        })
      })
    },
    doChange(val) {
      this.show = true
    },
    getCount(name) {
      this.$nextTick(() => {
        if (this.$refs[name]) {
          const childrenNodes = Array.from(this.$refs[name][0].children)
          const highLightItems = childrenNodes.filter((node) => {
            return node.className.includes('hightlight')
          })
          this.$refs[`${name}-value`][0].innerHTML = highLightItems.length
        } else {
          return 0
        }
      })
    }
  }
}
